'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bus';
var width = 448;
var height = 512;
var aliases = [128653];
var unicode = 'f207';
var svgPathData = 'M96 32C60.7 32 32 60.7 32 96l0 32 384 0 0-32c0-35.3-28.7-64-64-64L96 32zM32 160l0 96 176 0 0-96-176 0zm208 0l0 96 176 0 0-96-176 0zM32 288l0 96c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-96-384 0zM0 256L0 96C0 43 43 0 96 0L352 0c53 0 96 43 96 96l0 288c0 23.7-12.9 44.4-32 55.4l0 56.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-320 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-56.6C12.9 428.4 0 407.7 0 384L0 256zm72 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;